const ewLogo = "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Expansive_Worlds_Hori_RGB_Yellow.png";
const asgLogo = "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Avalanche_Studios_Group_Hori_RGB_White.png";
const trtLogo = "https://acp-portal-assets.avalanchestudios.com/COTWtheANGLER_Logo_light_FINAL (1) (1).png";
const srLogo = "https://acp-portal-assets.avalanchestudios.com/CompanyLogos/Systemic_Reaction_Hori_RGB_Cyan.png";

const asgTheme =  {
    light: {
      primary: '#000000',
      secondary: '#FF4200',
      accent: '#0DD3C0',
      tertiary: '#F9B63E',
      text: '#000'
    },
    backgrounds: {
      header: '#000',
      body: '#fff',
      footer: '#000'
    }
};
const srTheme = {
    light: {
      primary: '#0DD3C0',
      secondary: '#FF4200',
      accent: '#0DD3C0',
      tertiary: '#F9B63E',
      text: '#fff'
    },
    backgrounds: {
      header: '#00042A',
      body: '#00042A',
      footer: '#000'
    }
};
const ewTheme = {
    light: {
      primary: '#FFFFFF',
      secondary: '#427850',
      accent: '#786057',
      tertiary: '#F9B63E',
      text: '#fff'
    },
    backgrounds: {
      header: '#153D27',
      body: '#153D27',
      footer: '#000'
    }
};
const trtTheme = {
    light: {
      primary: '#000000',
      secondary: '#FF4200',
      accent: '#0DD3C0',
      tertiary: '#F9B63E',
      text: '#000'
    },
    backgrounds: {
      header: '#000',
      // body: '#59adba',
      body: 'url("https://acp-portal-assets.avalanchestudios.com/cover_art/the_angler_bg_center.jpg")',
      footer: '#000'
    }
};

const themes = {
  asg: {
    theme: asgTheme, 
    logo: asgLogo
  },
  ew: {
    theme: ewTheme,
    logo: ewLogo
  },
  sr: {
    theme: srTheme,
    logo: srLogo
  },
  trt: {
    theme: trtTheme,
    logo: trtLogo
  }
};

module.exports = { themes }